import type { ChartPayload, TablePayload } from '../../types';
import {
  currentLocale,
  formatMoney,
  formatMoneyTick,
  moneyAxisFormatter,
  formatNumber,
} from '../money.ts';
import { formatCell } from '../table/model.ts';

/** The native chart uses the same declared units and viewer locale as its table. */
export function nativeValueFormat(
  chart: ChartPayload,
  columns: TablePayload['columns'] | undefined,
  key: string,
  { locale, maximumTick }: { locale?: string; maximumTick?: number } = {},
) {
  const column: TablePayload['columns'][number] = columns?.find((column) => column.key === key) ?? {
    key,
    label: key,
  };
  const currency = chart.currency ?? column.currency;
  const viewerLocale = locale ?? currentLocale();
  const type = currency ? 'money' : column.type === 'money' ? 'number' : (column.type ?? 'number');
  const moneyTick =
    maximumTick === undefined
      ? (value: number) => formatMoneyTick(value, viewerLocale)
      : moneyAxisFormatter(viewerLocale, maximumTick);
  return {
    tick: (value: number) =>
      currency
        ? moneyTick(value)
        : type === 'percent'
          ? formatCell(value, column, type, viewerLocale)
          : formatNumber(value, viewerLocale, { notation: 'compact', maximumFractionDigits: 1 }),
    value: (value: number) =>
      locale !== undefined
        ? currency
          ? formatMoney(value, viewerLocale, currency, { precision: column.precision })
          : formatCell(value, column, type, viewerLocale)
        : String(value),
  };
}
